var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoReversed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 435,
    viewBox: "0 0 435 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1831_1393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.831 79.5C285.694 79.5 302.2 89.0299 311.132 104.5L361.764 192.198C370.696 207.668 370.696 226.728 361.764 242.198L311.132 329.896C302.2 345.366 285.694 354.896 267.831 354.896L166.566 354.896C148.702 354.896 132.196 345.366 123.264 329.896L72.6318 242.198C63.7001 226.728 63.7002 207.668 72.6318 192.198L123.264 104.5C132.196 89.0299 148.702 79.5 166.566 79.5L267.831 79.5Z",
    fill: "#006278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 139C236.311 152.649 214 186.018 214 186.018C213 187.5 212 189 210 189C208 189 207.5 188 206.428 186.018C206.428 186.018 193.401 158.57 189 147.5C187 142.47 183.8 140 177 140C170.2 140 162.167 140 159 140L198.5 228.5C199.5 230.5 200 232 200 233.5C200 237.1 200 267.5 200 280",
    stroke: "#00E8BB",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 143.5C144.5 143.5 170.809 194.773 184.5 229C185.5 231.5 185.5 233 185.5 236C185.5 256.503 185.5 286.5 185.5 286.5C185.5 292 190.5 300.5 200.5 300.5C210.5 300.5 215 292 215 286.5C215 286.5 215 238 215 236C215 234.5 215 231.5 216.5 229C236.765 195.225 262 156 262 156",
    stroke: "#01D66E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 297C229 277.5 229 237.8 229 235C229 232.2 229.5 230.5 231.5 227L289 137C284.333 137 274 137 270 137C266 137 259 140 256 145L214.5 208C213.833 209 212 211 209 211C206 211 204.5 210 203.5 208L177.5 153.5",
    stroke: "#00ACBC",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 283,
    width: 10,
    height: 57,
    transform: "rotate(-180 205 283)",
    fill: "url(#paint0_linear_1831_1393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 299,
    width: 8.00001,
    height: 63,
    transform: "rotate(-180 233 299)",
    fill: "url(#paint1_linear_1831_1393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.229,
    y: 150,
    width: 5.30374,
    height: 61,
    transform: "rotate(31.8936 262.229 150)",
    fill: "url(#paint2_linear_1831_1393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.383,
    y: 134.808,
    width: 5.86504,
    height: 42.3644,
    transform: "rotate(31.8936 243.383 134.808)",
    fill: "url(#paint3_linear_1831_1393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 143.285L146.786 141L173.067 196.048L168.281 198.333L142 143.285Z",
    fill: "url(#paint4_linear_1831_1393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 151.285L177.786 149L200.093 195.723L195.307 198.008L173 151.285Z",
    fill: "url(#paint5_linear_1831_1393)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1831_1393",
    x1: 210,
    y1: 283,
    x2: 210,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006278",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1831_1393",
    x1: 237,
    y1: 299,
    x2: 237,
    y2: 362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006278",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1831_1393",
    x1: 264.88,
    y1: 150,
    x2: 264.88,
    y2: 211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006278",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1831_1393",
    x1: 246.315,
    y1: 134.808,
    x2: 246.315,
    y2: 177.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006278",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1831_1393",
    x1: 144.393,
    y1: 142.143,
    x2: 170.674,
    y2: 197.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006278",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1831_1393",
    x1: 175.393,
    y1: 150.143,
    x2: 197.7,
    y2: 196.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006278",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1831_1393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434.396,
    height: 434.396,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReversed);
export default __webpack_public_path__ + "static/media/Logo - reversed.c11fe6de22e978b6823d5413ea036609.svg";
export { ForwardRef as ReactComponent };